// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-12-11T11:33:07+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  190785
//    Project:        617
//    Environment:    7626 - master
//    MD5:            fc19f8218ee423d48502dad6c3ac2595
//    Signature:      eyJpdiI6IlwvY1BSUk1WT3Q0SDI4OENucnRndVdBPT0iLCJ2YWx1ZSI6IjlYdUxKZytPVGdiRHNVQ1F6bldaTk1URHRHb3IyTHkzMDdJYnVka1Y2cE9TTkM1WmVVQTFsd2RqWjIxRzVGaEVmWWhvc0k3YVwvbmJNYllNbjFNSU9WZ0I1N0lYNmlsWUNCOUR2K01ZaStXeGRKSmxvc3lKNWZ0ZWgxcTZ1SmhBUUxUZDR6WXZGZTZEK2FPTUpNN1FcLzZUcWFtOHZWUXU1SlZHS0VkMk5FaVJ4NTgzVklxWW1sc3VIV3dHZ3hPZDB1WTlpWXNhc1FuTGFEblFjWHh4NkVpQjZIbEJCYmFXd0xSTFFvWHF0QnhDTjNidnlcL2ZkM3N6KzNCV2g3NTlCZFVkSkRwb1paendYVFZwcVZCbjBiMlZBR0UzQVBpejFYbXFhRnI1YkRvVkdhZWdSWlJxdVkzUjVXdE1tS1d1bnR6d3lSb3R5SUVDMlJrSVNLdnJOSlN3V3lEcTZ5dGhTcGIrV1NSdFY5K2RSU2l3XC9uZVNKZ0c3MzZWZWg3ckF2MTZHRFM0N1lIYXh0akpseFhYZGh5R29LY0JYVzF6cTF2ZTYxT3NTeHFpWFRnPSIsIm1hYyI6ImU0M2U4YmViYWU1MTY3YjMxNWI5ZGUwNDY3MmM3ZDE1N2E1ZTc5Y2Y0NGRjNWNkMTI1NTUwNDhhMmRjZDUxNTgifQ==
const termsCheckbox = document.getElementById('terms');
const subscribeButton = document.getElementById('Subscribe');

if (termsCheckbox && subscribeButton) {
termsCheckbox.addEventListener('change', function() {
  subscribeButton.disabled = !this.checked;
});
}